globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Profile = appCustomerSpace.Controllers.Profile || {};

appCustomerSpace.Controllers.Profile.ContactController = (function(superClass) {

    utils.extend(ContactController, superClass);

    function ContactController() {
      return ContactController.__super__.constructor.apply(this, arguments);
    }

    $.extend(ContactController.prototype, {
      init: function(){

        var $communicationChannelPreferencesPanel = $('.communication-channel-preferences-panel');
        var $allCommunicationsSwitchery           = $communicationChannelPreferencesPanel.find('.all-communications-switchery');
        var $allCommunicationsOffAlert            = $communicationChannelPreferencesPanel.find('.all-communications-off-alert');
        var $communicationChannelPreferencesList  = $communicationChannelPreferencesPanel.find('.communication-channel-preferences-list');
        var $reactivateAllCommunicationsBtn       = $communicationChannelPreferencesPanel.find('.reactivate-all-communications-btn');
        var $form                                 = $communicationChannelPreferencesPanel.closest('form');
        var $allCommunicationsChannelStatusInput  = $form.find('.all-communications-channel-status-input');

        $allCommunicationsSwitchery.on('change', 'input[type=checkbox]', function(e) {
            e.preventDefault();
            var $checkbox = $(this);

            if($checkbox.is(':checked')) {
                $allCommunicationsOffAlert.hide();
                $communicationChannelPreferencesList.show();
                $allCommunicationsChannelStatusInput.val("realtime");
                $form.submit();
            } else {
                $allCommunicationsOffAlert.show();
                $communicationChannelPreferencesList.hide();
                $allCommunicationsChannelStatusInput.val("disabled");
                $form.submit();
            }
        });

        $allCommunicationsSwitchery.on('click', '.switchery', function(e) {
            e.preventDefault();
        });

        $reactivateAllCommunicationsBtn.on('click', function(e) {
            e.preventDefault();

            $allCommunicationsChannelStatusInput.val("realtime");
            $form.submit();
        })

        return ContactController.__super__.init.apply(this, arguments);
      }
    })

    return ContactController;

})(appCustomerSpace.Controllers.MainController);
